import { render, staticRenderFns } from "./returnPageDialog.vue?vue&type=template&id=351c121c&scoped=true"
import script from "./returnPageDialog.vue?vue&type=script&lang=js"
export * from "./returnPageDialog.vue?vue&type=script&lang=js"
import style0 from "./returnPageDialog.vue?vue&type=style&index=0&id=351c121c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c121c",
  null
  
)

export default component.exports